import { useMemo } from 'react';
import { prop } from 'ramda';

import { useFilterDynamicCategory } from 'js/app/components/main/Games/hooks/useFilterDynamicCategory';
import { useGameComponentConfig } from 'js/app/components/main/Games/hooks/useGameComponentConfig';
import { useGamesSelector } from 'js/app/components/main/Games/store/context';
import { getPositionExcludingExisting } from 'js/app/components/main/Games/utils';
import { useCurrentItemMenu } from 'js/app/hooks/menu/useMenu';
import { useUserSelector } from 'js/store/hooks';

export const useGameMenuItems = () => {
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const currentItemMenu = useCurrentItemMenu();
    const { isSubPages = false } = useGameComponentConfig();
    const filterCategory = useFilterDynamicCategory();
    const { dynamicCategories, categories, feed } = useGamesSelector();

    return useMemo(() => {
        if (!feed.name) {
            return [];
        }

        const currentItemChildPages = currentItemMenu?.children || [];

        const getPositionCategory = getPositionExcludingExisting({
            initialPosition: (feed.categories[feed.categories.length - 1]?.position || 0) + 1,
            existingPositions: dynamicCategories.map(({ position }) => position)
        });

        const subPagesToCategories = isSubPages && currentItemChildPages.length
            ? currentItemChildPages.reduce((acc, categoryToAdd, index) => {
                if (
                    !categoryToAdd?.roles.includes('USER') && isLoggedIn
                    || !categoryToAdd?.roles.includes('GUEST') && !isLoggedIn
                ) {
                    return acc;
                }

                return [
                    ...acc,
                    {
                        name: categoryToAdd.name,
                        url: categoryToAdd.url,
                        isSubPage: true,
                        position: getPositionCategory(index)
                    }
                ];
            }, [])
            : [];

        return [...categories.filter(filterCategory), ...subPagesToCategories]
            .sort((categoryA, categoryB) => categoryA.position - categoryB.position);
    }, [
        categories, currentItemMenu?.children, dynamicCategories, filterCategory, isLoggedIn, feed, isSubPages
    ]);
};
